"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ActivityType;
(function (ActivityType) {
    ActivityType["MESSAGE"] = "MESSAGE";
    ActivityType["ACTIVITY"] = "ACTIVITY";
    ActivityType["BIRTHDAY_NOTIFICATION"] = "BIRTHDAY_NOTIFICATION";
    ActivityType["DELETE_USER"] = "DELETE_USER";
    ActivityType["TRAINER_NOTIFICATION"] = "TRAINER_NOTIFICATION";
})(ActivityType || (ActivityType = {}));
exports.default = ActivityType;
//# sourceMappingURL=ActivityType.js.map